import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  TextField,
  Grid,
  Select,
  MenuItem,
  Button,
  useMediaQuery,
  Typography,
  FormControl,
  Input,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import clsx from "clsx";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Tooltip from "@mui/material/Tooltip";
import { PASSWORD_TOOL_TIP } from "../../utils/constants";
import { userDetailsValidation } from "../../utils/validation";

const classes = {
  root: `root`,
  margin: `margin`,
  textField: `textField`,
};
const Div = styled("div")(({ theme }) => ({
  [`& .${classes.root}`]: {
    display: "flex",
    flexWrap: "wrap",
  },
  [`& .${classes.margin}`]: {
    margin: theme.spacing(1),
  },
  [`& .${classes.textField}`]: {
    width: "23ch",
  },
}));
function CreateUserModel(props) {
  const { open, handleClose, handleAgree, createdUser, setCreatedUser } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [values, setValues] = React.useState({
    amount: "",
    password: "",
    Cpassword: "",
    weight: "",
    weightRange: "",
    showPassword: false,
    showCPassword: false,
  });
  const [error, setError] = useState();
  useEffect(() => {
    setError({
      firstName: false,
      lastName: false,
      userName: false,
      email: false,
      emailMissMatch: false,
      password: false,
      Cpassword: false,
      passwordMissMatch: false,
      passwordNotValid: false,
      mobileNotValid: false,
      mobile: false,
      role: false,
    });
  }, [setCreatedUser, createdUser]);

  const handleClickShowPassword = (type) => {
    if (type == "password") {
      setValues({ ...values, showPassword: !values.showPassword });
    } else if (type == "Cpassword") {
      setValues({ ...values, showCPassword: !values.showCPassword });
    }
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleCreate = () => {
    const accessCreate = userDetailsValidation(createdUser, setError);
    if (accessCreate) {
      handleAgree();
    }
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
      style={{ width: "100%" }}
    >
      <Div>
        <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
          {"Create User"}
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-description">
                  Deletion Need Admin Approval, Are You Sure you Need To Delete {vehicle?.vehicleType}
                </DialogContentText> */}
          <Grid container spacing={0} style={{ display: "block" }}>
            <div style={{ display: "flex" }}>
              <Grid item>
                <InputLabel style={{ margin: "5px" }}>First Name</InputLabel>
                <TextField
                  id="firstName"
                  variant="outlined"
                  style={{ margin: "5px", width: "240px" }}
                  required
                  onChange={(val) =>
                    setCreatedUser((preVal) => ({
                      ...preVal,
                      firstName: val.target.value,
                    }))
                  }
                />
                {error?.firstName && (
                  <Typography component={"p"} style={{ color: "red" }}>
                    please enter first Name
                  </Typography>
                )}
              </Grid>
              <Grid item>
                <InputLabel style={{ margin: "5px" }}>Last Name</InputLabel>
                <TextField
                  id="lastName"
                  variant="outlined"
                  style={{ margin: "5px", width: "240px" }}
                  required
                  onChange={(val) =>
                    setCreatedUser((preVal) => ({
                      ...preVal,
                      lastName: val.target.value,
                    }))
                  }
                />
                {error?.lastName && (
                  <Typography component={"p"} style={{ color: "red" }}>
                    please enter last Name
                  </Typography>
                )}
              </Grid>
            </div>
            <Grid item>
              <InputLabel style={{ margin: "5px" }}>User Name</InputLabel>
              <TextField
                id="userName"
                variant="outlined"
                style={{ margin: "5px", width: "500px" }}
                required
                onChange={(val) =>
                  setCreatedUser((preVal) => ({
                    ...preVal,
                    userName: val.target.value,
                  }))
                }
              />
              {error?.userName && (
                <Typography component={"p"} style={{ color: "red" }}>
                  please enter user Name
                </Typography>
              )}
            </Grid>
            <Grid item>
              <InputLabel style={{ margin: "5px" }}>Email</InputLabel>
              <TextField
                id="email"
                variant="outlined"
                type="email"
                style={{ margin: "5px", width: "500px" }}
                required
                onChange={(val) =>
                  setCreatedUser((preVal) => ({
                    ...preVal,
                    email: val.target.value,
                  }))
                }
              />
              {error?.email && (
                <Typography component={"p"} style={{ color: "red" }}>
                  please enter email
                </Typography>
              )}
              {error?.emailMissMatch && (
                <Typography component={"p"} style={{ color: "red" }}>
                  please enter valid email address
                </Typography>
              )}
            </Grid>
            <div style={{ display: "flex" }}>
              <Grid item style={{ marginRight: "40px" }}>
                <InputLabel
                  style={{ margin: "5px", display: "flex", gap: "5px" }}
                >
                  Password{" "}
                  <Tooltip title={PASSWORD_TOOL_TIP}>
                    <HelpOutlineIcon />
                  </Tooltip>
                  <Tooltip />
                </InputLabel>
                <FormControl
                  className={clsx(classes.margin, classes.textField)}
                >
                  <Input
                    id="standard-adornment-password"
                    type={values.showPassword ? "text" : "password"}
                    style={{
                      width: "240px",
                      border: "1px solid gray",
                      padding: "10px",
                      borderRadius: "5px",
                    }}
                    onChange={(val) =>
                      setCreatedUser((preVal) => ({
                        ...preVal,
                        password: val.target.value,
                      }))
                    }
                    endAdornment={
                      <InputAdornment position=" end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => handleClickShowPassword("password")}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {values.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  {error?.password && (
                    <Typography component={"p"} style={{ color: "red" }}>
                      please enter password
                    </Typography>
                  )}
                  {error?.passwordNotValid && (
                    <Typography component={"p"} style={{ color: "red" }}>
                      please enter valid Password
                    </Typography>
                  )}
                </FormControl>
              </Grid>
              <Grid item>
                <InputLabel style={{ margin: "5px" }}>
                  Confirm Password
                </InputLabel>
                <FormControl
                  className={clsx(classes.margin, classes.textField)}
                >
                  <Input
                    id="standard-adornment-Cpassword"
                    type={values.showCPassword ? "text" : "password"}
                    style={{
                      width: "240px",
                      border: "1px solid gray",
                      padding: "10px",
                      borderRadius: "5px",
                    }}
                    onChange={(val) =>
                      setCreatedUser((preVal) => ({
                        ...preVal,
                        Cpassword: val.target.value,
                      }))
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => handleClickShowPassword("Cpassword")}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {values.showCPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  {error?.Cpassword && (
                    <Typography component={"p"} style={{ color: "red" }}>
                      please enter Confirm password
                    </Typography>
                  )}
                </FormControl>
              </Grid>
            </div>
            {error?.passwordMissMatch && (
              <Typography component={"p"} style={{ color: "red" }}>
                password miss match,please check
              </Typography>
            )}
            <div style={{ display: "flex" }}>
              <Grid item>
                <InputLabel style={{ margin: "5px" }}>Mobile</InputLabel>
                <TextField
                  id="mobileNo"
                  variant="outlined"
                  placeholder="Ex: +1 xxx xxx xxxx"
                  type="phone"
                  style={{ margin: "5px", width: "250px" }}
                  required
                  onChange={(val) =>
                    setCreatedUser((preVal) => ({
                      ...preVal,
                      mobile: val.target.value,
                    }))
                  }
                />
                {error?.mobile && (
                  <Typography component={"p"} style={{ color: "red" }}>
                    please enter Mobile Number
                  </Typography>
                )}
                {error?.mobileNotValid && (
                  <Typography component={"p"} style={{ color: "red" }}>
                    please enter Valid Mobile Number
                  </Typography>
                )}
              </Grid>
              <Grid item>
                <InputLabel style={{ margin: "8px" }}>Roles</InputLabel>
                <FormControl variant="outlined" style={{ width: "250px" }}>
                  <Select
                    labelId="demo-simple-select-filled-label"
                    id="demo-simple-select-filled"
                    onChange={(val) =>
                      setCreatedUser((preVal) => ({
                        ...preVal,
                        role: val.target.value,
                      }))
                    }
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value="user">User</MenuItem>
                    <MenuItem value="admin">Admin</MenuItem>
                  </Select>
                  {error?.role && (
                    <Typography component={"p"} style={{ color: "red" }}>
                      please select a role
                    </Typography>
                  )}
                </FormControl>
              </Grid>
            </div>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            style={{ border: "1px solid #35AA2B" }}
            autoFocus
          >
            Skip
          </Button>
          <Button
            onClick={handleCreate}
            style={{
              backgroundColor: "#35AA2B",
              color: "#05234A",
              fontWeight: "600px",
            }}
          >
            Create
          </Button>
        </DialogActions>
      </Div>
    </Dialog>
  );
}

export default CreateUserModel;
